// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"0bca617db1ce019e","6831":"c29eaca5dc47f70e","8503":"8011294a330d264b","9683":"a6196a058f873072"}[chunkId] + ".js";
};